const directPlacement = {
  id: null,
  clientId: null,
  clientName: null,
  salary: null,
  paymentReceived: null,
  placementDate: null,
  lastPaymentReceivedDate: null,
  employeeName: null,
  jobTitle: null,
  isPaidInFull: null,
  commissions: [],
  payments: [],
  expenses: [],
  defaultExpensesByClient: [],
  expensesDeduction: 0,
  expensesDeductionHint: '',
  feeTypeId: null,
  invoiceDate: null,
  invoiceDueDate: null,
  fee: null
}

export default () => Object.assign({}, directPlacement)
